import { ThemeUICSSObject } from 'theme-ui';
import primary from './primary';
import mobx from './mobx';

export const trees: ThemeUICSSObject = {
  mobx,
  primary,
};
